/* import __COLOCATED_TEMPLATE__ from './set-conversation-data-attribute.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();